import React, { useState } from 'react';
import Card from '../common/Card';
import LoadingSpinner from '../common/LoadingSpinner';

interface PictureOptionProps {
    imageUrl: string;
    isAI: boolean;
    position: 'left' | 'right';
    onSelect: (isAI: boolean) => void;
    disabled: boolean;
}

const PictureOption: React.FC<PictureOptionProps> = ({
    imageUrl,
    isAI,
    position,
    onSelect,
    disabled,
}) => {
    const [isLoading, setIsLoading] = useState(true);

    // Simple click handler without delays or state
    const handleClick = () => {
        if (disabled) return;
        onSelect(isAI);
    };

    const handleImageLoad = () => {
        setIsLoading(false);
    };

    // Transform URL to use proxy if it's from the Railway backend
    // This avoids CSP issues in Discord Activity
    const displayUrl = imageUrl.replace(
        'https://ai-guessing-game-production.up.railway.app/api/images',
        '/api/proxy/images'
    );

    return (
        <Card
            onClick={handleClick}
            disabled={disabled}
            className={`h-full flex flex-col min-h-[300px] ${disabled ? 'opacity-70' : ''
                } p-0 overflow-hidden`} // Remove padding for image to fill card
        >
            <div className="absolute top-4 left-4 z-10">
                <span className={`inline-block px-3 py-1 text-xs font-mono font-bold rounded-lg tracking-wider uppercase ${position === 'left'
                    ? 'bg-gradient-to-r from-primary-500 to-primary-600 text-white shadow-neon'
                    : 'bg-gradient-to-r from-secondary-500 to-secondary-600 text-white shadow-[0_0_10px_rgba(251,191,36,0.5)]'
                    }`}>
                    Image {position === 'left' ? 'A' : 'B'}
                </span>
            </div>

            <div className="flex-grow relative w-full h-full min-h-[300px] bg-dark-900 flex items-center justify-center">
                {isLoading && (
                    <div className="absolute inset-0 flex items-center justify-center z-0">
                        <LoadingSpinner size="large" message="" />
                    </div>
                )}
                <img
                    src={displayUrl}
                    alt={`Option ${position === 'left' ? 'A' : 'B'}`}
                    className={`w-full h-full object-cover absolute inset-0 transition-opacity duration-300 ${isLoading ? 'opacity-0' : 'opacity-100'
                        }`}
                    loading="lazy"
                    onLoad={handleImageLoad}
                />
            </div>
        </Card>
    );
};

export default PictureOption;
